const prefix = 'phone';
type Feature =
  | 'call-queues'
  | 'call-groups'
  | 'departments'
  | 'device'
  | 'devices'
  | 'device-extension-route'
  | 'device-extension-routes'
  | 'voicemail-boxes'
  | 'audio-library'
  | 'phone-hours'
  | 'phone-numbers'
  | 'phone-trees'
  | 'phone-trees-quick-actions'
  | 'overrides'
  | 'call-routes'
  | 'call-route'
  | 'voicemail-box';
type Context = 'page' | 'setting';

export const trackingId = ({ context, feature, details }: { context: Context; feature: Feature; details: string }) =>
  `${prefix}::${context}::${feature}::${details}`;
